module.exports = __webpack_public_path__ + "assets/img/interests_bg.4b93303e.png";